export enum NewsRecapHeadlineType {
  AnalystNotes,
  UsExternal,
  NonUsExternal,
}
